let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("ffEVr"), load("lvR1M")]).then(() => parcelRequire('loik3'));